import React, {Component} from 'react';
import Helmet from 'react-helmet';

import DefaultLayout from '../Layout/DefaultLayout.jsx';
import {ImageHeader, ImageHeaderTitle, ImageHeaderBrief} from '../../components/ImageHeader/ImageHeader.jsx';
import TimelineSource from '../../components/Timeline/Timeline.jsx';
// import TimelineElement from '../../components/Timeline/TimelineElement.jsx';

import './Press.scss';

const title = "Ils parlent de nous";
const description = "Tous les articles de presse mentionnant Twineeds";

export default class Press extends Component {
  render() {
    const helmet = <Helmet>
      <title>{title}</title>
      <meta name="description" content={description}/>
      <meta property="og:description" content={description}/>
      <meta property="og:title" content={title}/>
    </Helmet>;

    return (
      <DefaultLayout showSidebarMenu={false} className="press" helmet={helmet}>
        <ImageHeader>
          <ImageHeaderTitle>
            <h1>Ils parlent de nous</h1>
          </ImageHeaderTitle>
          <ImageHeaderBrief>
            Retrouvez toutes les actualités de Twineeds
          </ImageHeaderBrief>
        </ImageHeader>
        <div className="container">
          <TimelineSource className="mt-5">
          </TimelineSource>
        </div>
      </DefaultLayout>
    );
  }
}